import { get, post, put } from '../Services/http';
import { catchError } from './Error.action';
export const FAVOURITES_SET_LISTS = 'FAVOURITES_SET_LISTS';
export const FAVOURITES_SUBMIT_ERROR = 'FAVOURITES_SUBMIT_ERROR';
export const FAVOURITES_CREATE_LIST = 'FAVOURITES_CREATE_LIST';

export const addToFavourites = (articleNumber, favouritesClass) => {
    return (dispatch) => {
        return post('/api/favourites/addToFavourites', { articleNumber, favouritesClass })
            .then(response => response.json())
            .catch(ex => dispatch(catchError(ex, error => submitError(error))));
    }
}

export const addManyToFavourites = (articles) => {
    return (dispatch) => {
        return post('/api/favourites/addManyToFavourites', articles)
            .then(response => response.json())
            .catch(ex => dispatch(catchError(ex, error => submitError(error))));
    }
}
export const setList = (listId) => {
    return (dispatch) => {
        if (!listId) {
            return;
        }
        return post('/api/favourites/setList', { listId })
            .then(response => response.json())
            .then(response => {
                if (response.data == 200) {
                    return response;
                }
            })
            .catch(ex => dispatch(catchError(ex, error => submitError(error))));
    }
}

export const goToList = (listId) => {
    return (dispatch) => {
        if (!listId) {
            return;
        }
        return put('/api/favourites/goToList', { listId })
            .then(response => response.json())
            .then(response => {
                if (response.data == 200) {
                    return response;
                }
            })
            .catch(ex => dispatch(catchError(ex, error => submitError(error))));
    }
}

export const setLists = lists => (
    {
    type: FAVOURITES_SET_LISTS,
        lists: lists
    }
);

export const createList = (listName) => (dispatch, getState) => {
    return post('/api/favourites/createList', { listName })
        .then(response => response.json())
        .then(response => {
            if (response.data != null) {
                return response.data;
            }
        })
        .catch(ex => dispatch(catchError(ex, error => submitError(error))));

}
export const submitError = error => ({
    type: FAVOURITES_SUBMIT_ERROR,
    payload: {
        error,
    },
})